<div id="map-container" class="map-container">
    <iframe
      width="600"
      height="450"
      frameborder="0"
      style="border:0"
      src="https://www.google.com/maps/embed/v1/place?key=1da6fc96dd9c409a9694130cd4c7a896&q=HCH+House,+Horton+Road,Colnbrook,SL3+0AT,London+Heathrow,United+Kingdom"
      allowfullscreen>
    </iframe>
  </div>